/**
 * 能力类型分类占比组件
 * zxw
 * 2024-01-21
 */
import React, { useEffect, useState } from 'react';
import { Chart } from '@antv/g2';
import CNF from '../../incs/Config.js';

const UserUDATC = (props) => {
    const [data, setData] = useState([]);

    useEffect(()=>{
        if (props.data) setData(props.data);
    }, [props]);

    useEffect(()=>{
        const chart = new Chart({
            container: props.container ? props.container : 'antv-g2-id',
            autoFit: props.isMobileDevice ? true : false,
        });

        chart.title({
            title: '能力类型分类占比',
            subtitle: '展示各种能力类型人才数占比，使用百分比。',
        });
        chart.data(data);
        chart.coordinate({ type: 'theta', outerRadius: 0.8 });
        chart
            .interval()
            .transform({ type: 'stackY' })
            .encode('y', 'percent')
            .encode('color', 'type')
            .legend('color', { position: 'top', layout: { justifyContent: 'left' } })
            .animate('enter', { 
                type: 'waveIn',
                duration: 1000,
            })
            .scale('color', {
                range: CNF.swatches.default,
            })
            .label({
                position: props.isMobileDevice ? 'inside' : 'spider',
                text: (data) => `${data.type}: ${data.percent}%`,
            })
            .tooltip((data) => ({
                name: data.type,
                value: `${data.percent}%`,
            }));
        chart.render();

        return ()=>{
            chart.destroy();
        }
    },[data]);

    return <div id='antv-g2-id'></div>
}

export default UserUDATC;